import React from 'react'
import { withStyles } from '@material-ui/core/styles'
import { useForm, Form, Field, useWatch } from '../../../form'
import { Translation } from 'react-i18next'
import classNames from 'classnames'
import MenuItem from '@material-ui/core/MenuItem'
import Button from '@material-ui/core/Button'
import PasswordContainer from '../../../containers/employer/companyProfile/password.container'
import WorkField from '../common/fieldOfWorkSelect'
import { companyProfileValidate } from '../../../containers/employer/validate'
import SnackbarComponent from '../../../utils/employer/snackbarComponent.utils'
import { scrollToTop } from '../../../utils/scrollTo'
import CountrySelectField from '../../common/countrySelectField'

/**
 * @author Huong Nguyen
 */

class CompanyProfileComponent extends React.Component {
  componentDidMount() {
    this.props.getCountryList()
    this.props.getFieldOfWork()
    this.props.getOperatorsEinvoice()
    this.props.loadProfileStart()
    this.props.getTotalApplications()
    scrollToTop()
  }

  render() {
    return <CompanyProfile {...this.props} />
  }
}

const styles = (theme) => ({
  textField: {
    marginTop: theme.spacing(4)
  },
  textField1: {
    marginTop: theme.spacing(4),
    border: '1px solid gray',
    fontWeight: 500
  },
  textField2: {
    marginTop: theme.spacing(4),
    color: '#000000',
    fontWeight: 500
  },
  resize: {
    fontSize: '14px'
  },
  button: {
    marginTop: theme.spacing(2),
    float: 'right',
    [theme.breakpoints.down('xs')]: {
      width: '100%'
    }
  },
  select: {
    marginTop: theme.spacing(4),
    border: '1px solid gray',
    fontWeight: 500,
    fontSize: '14px'
  }
})

const defaultValues = {
  conmpanyName: '',
  contactName: '',
  address: '',
  billing_method: '',
  companyEmail: '',
  phoneNumber: '',
  city: '',
  e_invoice_address: '',
  businessID: '',
  field_work: '',
  zipCode: '',
  country: 1,
  e_invoice_operator: ''
}

const CompanyProfile = ({
  classes,
  fieldOfWork,
  eInvoiceOperators,
  updateProfile,
  showSnackbar,
  showFailedSnackbar,
  closeProfileSnackbar,
  countryList
}) => {
  const form = useForm({
    name: 'companyProfile',
    onSubmit: onSubmit,
    defaultValues: defaultValues,
    validator: companyProfileValidate,
    resetOnSubmit: false
  })

  const { control } = form

  function onSubmit(values) {
    updateProfile(values)
  }

  const { billing_method } = useWatch({
    fields: 'billing_method',
    control: control
  })

  return (
    <Translation>
      {(t) => {
        return (
          <div className="container">
            <div className="row">
              <div className="dashboard-content-header">
                <h1>{t('employer.companyProfile.h1')}</h1>
              </div>
            </div>
            <div className="row">
              <div className="dashboard-content-header">
                <div className="col-xs-12 col-sm-12 col-lg-12">
                  <div className="panel panel-default">
                    <div className="panel-heading">
                      <h3 className="panel-title"></h3>
                    </div>
                    <div className="panel-body pd=0">
                      <Form {...form}>
                        <div className="col-xs-12 col-sm-6 col-md-3 col-lg-3">
                          <Field
                            name="conmpanyName"
                            label={t('employer.companyProfile.label1')}
                            inputType="textfield"
                            control={control}
                            className={classNames(
                              classes.textField2,
                              classes.resize
                            )}
                            disabled={true}
                          />
                          <Field
                            name="contactName"
                            label={t('employer.companyProfile.label4')}
                            inputType="textfield"
                            control={control}
                            className={classNames(
                              classes.textField1,
                              classes.resize
                            )}
                          />
                          <Field
                            name="address"
                            label={t('employer.companyProfile.label7')}
                            inputType="textfield"
                            control={control}
                            className={classNames(
                              classes.textField1,
                              classes.resize
                            )}
                            helperTextStyle={{
                              marginTop: '0px',
                              height: '0px'
                            }}
                          />
                          <Field
                            name="billing_method"
                            label={t('employer.companyProfile.label11')}
                            inputType="select"
                            control={control}
                            className={classNames(
                              classes.textField1,
                              classes.resize
                            )}
                          >
                            <MenuItem value="Sähköposti">
                              {t('employer.Sähköposti')}
                            </MenuItem>
                            <MenuItem value="Kirjeposti">
                              {t('employer.Kirjeposti')}
                            </MenuItem>
                            <MenuItem value="Verkkolasku">
                              {t('employer.Verkkolasku')}
                            </MenuItem>
                          </Field>
                        </div>
                        <div className="col-xs-12 col-sm-6 col-md-3 col-lg-3">
                          <Field
                            name="companyEmail"
                            label={t('employer.companyProfile.label2')}
                            inputType="textfield"
                            control={control}
                            className={classNames(
                              classes.textField2,
                              classes.resize
                            )}
                            disabled={true}
                          />
                          <Field
                            name="phoneNumber"
                            label={t('employer.companyProfile.label5')}
                            inputType="textfield"
                            control={control}
                            className={classNames(
                              classes.textField1,
                              classes.resize
                            )}
                            helperTextStyle={{
                              marginTop: '0px',
                              height: '0px'
                            }}
                          />
                          <Field
                            name="city"
                            label={t('employer.companyProfile.label8')}
                            inputType="textfield"
                            control={control}
                            className={classNames(
                              classes.textField1,
                              classes.resize
                            )}
                            helperTextStyle={{
                              marginTop: '0px',
                              height: '0px'
                            }}
                          />
                          <Field
                            name="e_invoice_address"
                            label={
                              billing_method === 'Verkkolasku'
                                ? t('employer.companyProfile.label14')
                                : t('employer.companyProfile.label12')
                            }
                            inputType="textfield"
                            control={control}
                            className={classNames(
                              classes.textField1,
                              classes.resize
                            )}
                            helperTextStyle={{
                              marginTop: '0px',
                              height: '0px'
                            }}
                          />
                        </div>
                        <div className="col-xs-12 col-sm-12 col-md-6 col-lg-6">
                          <Field
                            name="businessID"
                            label={t('employer.companyProfile.label3')}
                            inputType="textfield"
                            control={control}
                            className={classNames(
                              classes.textField2,
                              classes.resize
                            )}
                            disabled={true}
                          />
                          {/* huong - filed of work goes here */}
                          <WorkField
                            classes={classes}
                            fieldOfWork={fieldOfWork}
                            control={control}
                          />
                          <div className="row">
                            <div className="col-xs-5 col-md-5">
                              <Field
                                name="zipCode"
                                label={t('employer.companyProfile.label9')}
                                inputType="textfield"
                                control={control}
                                className={classNames(
                                  classes.textField1,
                                  classes.resize
                                )}
                                helperTextStyle={{
                                  marginTop: '0px',
                                  height: '0px'
                                }}
                              />
                            </div>
                            <div className="col-xs-7 col-md-7">
                              <CountrySelectField
                                t={t}
                                classes={classes}
                                countryList={countryList}
                                control={control}
                              />
                            </div>
                          </div>
                          {/* huong - e-invoice operator goes here*/}
                          <Field
                            name="e_invoice_operator"
                            label={
                              billing_method === 'Verkkolasku'
                                ? t('employer.companyProfile.label15')
                                : t('employer.companyProfile.label13')
                            }
                            inputType="select"
                            control={control}
                            className={classNames(
                              classes.textField1,
                              classes.resize
                            )}
                          >
                            {eInvoiceOperators}
                          </Field>
                        </div>
                        <div className="col-xs-12 col-sm-12 col-lg-12">
                          <Button
                            variant="contained"
                            type="submit"
                            className={classes.button}
                          >
                            {t('employer.companyProfile.label16')}
                          </Button>
                        </div>
                      </Form>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="row">
              <div className="dashboard-content-header">
                <h1>{t('employer.companyProfile.h1b')}</h1>
              </div>
            </div>
            <div className="row">
              <PasswordContainer />
            </div>
            <SnackbarComponent
              open={showSnackbar}
              message={t('employer.companyProfile.msg')}
              variant="success"
              autoHideDuration={3000}
              onClose={closeProfileSnackbar}
            />
            <SnackbarComponent
              open={showFailedSnackbar}
              message={t('employer.companyProfile.msg2')}
              variant="error"
              autoHideDuration={3000}
              onClose={closeProfileSnackbar}
            />
          </div>
        )
      }}
    </Translation>
  )
}

export default withStyles(styles)(CompanyProfileComponent)
